import DynamicFieldsSerializer from '@linc-technologies/linced-common/serializers/dynamic-fields';

export default class BulkImportContact extends DynamicFieldsSerializer {
  _fieldsKey = 'relationshipFields';
}
